import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from "react-router-dom";
import '../../css/BlogNavbar.css';

const BlogNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`tsb-nav ${scrolled ? 'tsb-nav--scrolled' : ''}`}>
      <div className="tsb-nav__container">
        {/* Logo Section */}
        <div className="tsb-nav__brand">
          <a href="/" className="tsb-nav__logo">
            <div className="tsb-nav__logo-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 4L4 10L16 16L28 10L16 4Z" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <path d="M4 16L16 22L28 16" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <path d="M4 22L16 28L28 22" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#00D4FF"/>
                    <stop offset="100%" stopColor="#7B2FF7"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span className="tsb-nav__logo-text">TechShara</span>
            <span className="tsb-nav__badge">Blog</span>
          </a>
        </div>

        {/* Desktop & Mobile Navigation Links */}
        <div 
          ref={menuRef}
          className={`tsb-nav__links ${isMenuOpen ? 'tsb-nav__links--open' : ''}`}
        >
          <ul className="tsb-nav__menu">
            <li>
              <NavLink
                to="/blog"
                className={({ isActive }) =>
                  "tsb-nav__link " + (isActive ? "tsb-nav__link--active" : "")
                }
                onClick={closeMenu}
              >
                Blog
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/learning-zone"
                className={({ isActive }) =>
                  "tsb-nav__link " + (isActive ? "tsb-nav__link--active" : "")
                }
                onClick={closeMenu}
              >
                Tutorials
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/tools"
                className={({ isActive }) =>
                  "tsb-nav__link " + (isActive ? "tsb-nav__link--active" : "")
                }
                onClick={closeMenu}
              >
                Free AI Tools
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/free-certificates"
                className={({ isActive }) =>
                  "tsb-nav__link " + (isActive ? "tsb-nav__link--active" : "")
                }
                onClick={closeMenu}
              >
                Free Certifications
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/language-translator"
                className={({ isActive }) =>
                  "tsb-nav__link " + (isActive ? "tsb-nav__link--active" : "")
                }
                onClick={closeMenu}
              >
                Multi-Language Translator
              </NavLink>
            </li>
          </ul>

          {/* Right side actions */}
          <div className="tsb-nav__actions">
            <a href="/" className="tsb-nav__cta" onClick={closeMenu}>
              <span>Back to Home</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19 12H5M5 12L11 6M5 12L11 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          ref={hamburgerRef}
          className={`tsb-nav__hamburger ${isMenuOpen ? 'tsb-nav__hamburger--open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Overlay for mobile */}
      {isMenuOpen && (
        <div className="tsb-nav__overlay" onClick={closeMenu}></div>
      )}
    </nav>
  );
};

export default BlogNavbar;